var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFE9E6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_413808)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_280_413808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_280_413808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5417 43.3334C18.5139 43.3334 17.625 42.9656 16.875 42.2301C16.125 41.4934 15.75 40.5973 15.75 39.5417V18.1251C15.2222 18.1251 14.7778 17.9373 14.4167 17.5617C14.0556 17.1873 13.875 16.7362 13.875 16.2084C13.875 15.6806 14.0556 15.2362 14.4167 14.8751C14.7778 14.514 15.2222 14.3334 15.75 14.3334H22.7917C22.7917 13.7779 22.9722 13.3195 23.3333 12.9584C23.6944 12.5973 24.1389 12.4167 24.6667 12.4167H31.3333C31.8611 12.4167 32.3056 12.5973 32.6667 12.9584C33.0278 13.3195 33.2083 13.7779 33.2083 14.3334H40.25C40.7778 14.3334 41.2222 14.514 41.5833 14.8751C41.9444 15.2362 42.125 15.6806 42.125 16.2084C42.125 16.7362 41.9444 17.1873 41.5833 17.5617C41.2222 17.9373 40.7778 18.1251 40.25 18.1251V39.5417C40.25 40.5973 39.875 41.4934 39.125 42.2301C38.375 42.9656 37.4861 43.3334 36.4583 43.3334H19.5417ZM19.5417 18.1251V39.5417H36.4583V18.1251H19.5417ZM22.8333 34.5417C22.8333 35.0417 23 35.4656 23.3333 35.8134C23.6667 36.1601 24.0833 36.3334 24.5833 36.3334C25.0833 36.3334 25.5072 36.1601 25.855 35.8134C26.2017 35.4656 26.375 35.0417 26.375 34.5417V23.1251C26.375 22.6251 26.2017 22.2012 25.855 21.8534C25.5072 21.5067 25.0833 21.3334 24.5833 21.3334C24.0833 21.3334 23.6667 21.5067 23.3333 21.8534C23 22.2012 22.8333 22.6251 22.8333 23.1251V34.5417ZM29.625 34.5417C29.625 35.0417 29.7989 35.4656 30.1467 35.8134C30.4933 36.1601 30.9167 36.3334 31.4167 36.3334C31.9167 36.3334 32.3333 36.1601 32.6667 35.8134C33 35.4656 33.1667 35.0417 33.1667 34.5417V23.1251C33.1667 22.6251 33 22.2012 32.6667 21.8534C32.3333 21.5067 31.9167 21.3334 31.4167 21.3334C30.9167 21.3334 30.4933 21.5067 30.1467 21.8534C29.7989 22.2012 29.625 22.6251 29.625 23.1251V34.5417Z",
    fill: "#FF5334"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_413808"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFile);
export default __webpack_public_path__ + "static/media/delete-file.e4125d30fd0716e887cdcd919aeb351b.svg";
export { ForwardRef as ReactComponent };